import { render, staticRenderFns } from "./CartWrapper.vue?vue&type=template&id=31c297f6&lang=pug&"
import script from "./CartWrapper.vue?vue&type=script&lang=js&"
export * from "./CartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports